import React from 'react';
import Index from './components/index.js';

const App = (props) => (
  <Index { ...props } />
);

export default App;